import type { ReactNode } from "react";
import { ProductDomPoster } from "../../components/product-dom-poster/ProductDomPoster";
import { spaceSubscribeGateLayoutCssVars } from "../../platform_spaces/space/Config";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { resolveProductPosterUrl } from "../../platform_spaces/space/spaceProductPurchaseUtils";
import "../../platform_spaces/space/SpaceStyle.css";

type Props = {
  row: MembershipProduct;
  children: ReactNode;
};

/** 产品未开通：海报 + 订阅 CTA 槽位（平台站与独立站共用布局） */
export function ProductSubscribeGate(props: Props): JSX.Element {
  const { row, children } = props;
  const webPosterSrc = resolveProductPosterUrl(row);
  return (
    <div
      className="space-access-gate space-access-gate--poster"
      aria-label="会员开通引导"
      style={spaceSubscribeGateLayoutCssVars()}
    >
      <div className="space-access-gate__inner space-access-gate__inner--poster">
        <div className="space-access-gate__poster-wrap">
          {webPosterSrc ? (
            <img src={webPosterSrc} alt="" className="space-access-gate__poster-img" />
          ) : (
            <ProductDomPoster productName={row.displayName} intro={row.description} />
          )}
          <div className="space-access-gate__poster-shade" aria-hidden />
          <div className="space-access-gate__poster-cta">{children}</div>
        </div>
      </div>
    </div>
  );
}
